// extracted by mini-css-extract-plugin
export var banner = "styles-module--banner--349d7";
export var bubble = "styles-module--bubble--cbc75";
export var content = "styles-module--content--60e56";
export var dashboardContainer = "styles-module--dashboardContainer--5a2b7";
export var detail = "styles-module--detail--a3020";
export var detailChildren = "styles-module--detailChildren--55808";
export var detailContent = "styles-module--detailContent--01915";
export var detailImage = "styles-module--detailImage--99527";
export var detailTitle = "styles-module--detailTitle--354f9";
export var details = "styles-module--details--e3083";
export var logo = "styles-module--logo--32912";